import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'

// React Router v7 - No need for external history, ReactPlugin will auto-detect
const reactPlugin = new ReactPlugin()
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.APP_INSIGHTS_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: {
        // React Router v7 auto-detection - no history needed
      },
    },
  },
})
appInsights.loadAppInsights()
export { reactPlugin, appInsights }
